import { ref, nextTick } from 'vue'

export function createHeightMeasurer() {
  let resizeObserver = null
  let mutationObserver = null
  let isMounted = true

  const measureElementHeight = (containerRef, selector, cssVarName) => {
    if (!isMounted || !containerRef.value) return

    // Text wrapping around the floats changes the height the floats are
    // sized from, so measure again until it settles
    const settle = () => {
      if (!isMounted || !containerRef.value) return
      const element = containerRef.value.querySelector(selector)
      if (!element) return

      for (let pass = 0; pass < 5 && element.offsetHeight > 0; pass++) {
        const height = `${element.offsetHeight}px`
        if (containerRef.value.style.getPropertyValue(cssVarName) === height) break
        containerRef.value.style.setProperty(cssVarName, height)
      }
    }

    nextTick(settle)

    // Always run timeout as fallback
    setTimeout(settle, 100)
  }

  const setupObservers = (containerRef, measureCallback) => {
    if (!containerRef.value) return

    window.addEventListener('resize', measureCallback)
    
    if (window.ResizeObserver) {
      resizeObserver = new ResizeObserver(measureCallback)
      resizeObserver.observe(containerRef.value)
    }
    
    mutationObserver = new MutationObserver(measureCallback)
    mutationObserver.observe(containerRef.value, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    })
  }

  const cleanup = (measureCallback) => {
    isMounted = false
    window.removeEventListener('resize', measureCallback)
    resizeObserver?.disconnect()
    mutationObserver?.disconnect()
  }

  return {
    measureElementHeight,
    setupObservers,
    cleanup
  }
}